"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
const getCapacityQuery_1 = require("./gql/getCapacityQuery");
class Capacity {
    constructor(client, dateTimeProvider, dateTimeModifier) {
        this.getCapacity = async () => {
            try {
                const dates = await this.client.fetch("availableStartDates", getCapacityQuery_1.getAvailableStartDatesQuery, null);
                const variables = (0, getCapacityQuery_1.generateVariablesFromAvailableStartDates)(dates.availableStartDates);
                if (Object.keys(variables).length === 0) {
                    throw new exception_1.DomainException("No available start dates");
                }
                const data = await this.client.fetch("myCapacities", (0, getCapacityQuery_1.generateCapacityQuery)(variables), variables);
                return Object.values(variables).map((date, index) => {
                    return this.mapCapacity(date, data.coach[`original${index}`], data.coach[`premium${index}`], data.coach[`plus${index}`], data.coach[`vip${index}`], data.coach[`pro${index}`]);
                });
            }
            catch (e) {
                const initialDate = this.getNextMonday();
                const date1 = this.dateTimeModifier.modifyDays(initialDate, 7);
                const date2 = this.dateTimeModifier.modifyDays(initialDate, 14);
                const date3 = this.dateTimeModifier.modifyDays(initialDate, 21);
                return [
                    this.mapCapacity(initialDate, null, null, null, null, null),
                    this.mapCapacity(date1, null, null, null, null, null),
                    this.mapCapacity(date2, null, null, null, null, null),
                    this.mapCapacity(date3, null, null, null, null, null),
                ];
            }
        };
        this.mapCapacity = (date, capacityOriginal, capacityPremium, capacityPlus, capacityVip, capacityPro) => {
            if (!capacityOriginal && !capacityPremium && !capacityPlus) {
                return this.createEmptyCapacity(date);
            }
            return {
                date,
                original: {
                    maximum: capacityOriginal.max,
                    taken: capacityOriginal.taken,
                    reserved: capacityOriginal.reserved,
                },
                premium: {
                    maximum: capacityPremium.max,
                    taken: capacityPremium.taken,
                    reserved: capacityPremium.reserved,
                },
                plus: {
                    maximum: capacityPlus.max,
                    taken: capacityPlus.taken,
                    reserved: capacityPlus.reserved,
                },
                vip: {
                    maximum: capacityVip.max,
                    taken: capacityVip.taken,
                    reserved: capacityVip.reserved,
                },
                pro: {
                    maximum: capacityPro.max,
                    taken: capacityPro.taken,
                    reserved: capacityPro.reserved,
                },
            };
        };
        this.createEmptyCapacity = (date) => {
            const emptyCapacity = 0;
            return {
                date,
                original: {
                    maximum: emptyCapacity,
                    taken: emptyCapacity,
                    reserved: emptyCapacity,
                },
                premium: {
                    maximum: emptyCapacity,
                    taken: emptyCapacity,
                    reserved: emptyCapacity,
                },
                plus: {
                    maximum: emptyCapacity,
                    taken: emptyCapacity,
                    reserved: emptyCapacity,
                },
                vip: {
                    maximum: emptyCapacity,
                    taken: emptyCapacity,
                    reserved: emptyCapacity,
                },
                pro: {
                    maximum: emptyCapacity,
                    taken: emptyCapacity,
                    reserved: emptyCapacity,
                },
            };
        };
        this.getNextMonday = () => {
            const currentDate = this.dateTimeProvider.currentDate();
            const currentDayOfWeek = this.dateTimeProvider.dayOfWeek(currentDate);
            return this.dateTimeModifier.modifyDays(currentDate, 7 - currentDayOfWeek);
        };
        this.setCapacity = async (capacity) => {
            const result = await this.client.fetch("setMyCapacity", `
mutation setMyCapacity($premium: Int!, $original: Int!, $plus: Int!, $pro: Int!, $vip: Int!) {
  setCoachCapacity(premium: $premium, original: $original, plus: $plus, pro: $pro, vip: $vip) {
    success
    messages
  }
}
`, {
                premium: capacity.premium.maximum,
                original: capacity.original.maximum,
                plus: capacity.plus.maximum,
                pro: capacity.pro.maximum,
                vip: capacity.vip.maximum,
            });
            if (!result.setCoachCapacity.success) {
                throw new exception_1.DomainException(result.setCoachCapacity.messages.join(", "));
            }
        };
        this.client = client;
        this.dateTimeProvider = dateTimeProvider;
        this.dateTimeModifier = dateTimeModifier;
    }
}
exports.default = Capacity;
//# sourceMappingURL=Capacity.js.map